import { render, staticRenderFns } from "./server-item.vue?vue&type=template&id=7c1166d1&scoped=true&"
import script from "./server-item.vue?vue&type=script&lang=js&"
export * from "./server-item.vue?vue&type=script&lang=js&"
import style0 from "./server-item.vue?vue&type=style&index=0&id=7c1166d1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1166d1",
  null
  
)

export default component.exports